import { render } from "./kycForm.vue?vue&type=template&id=4492b94a&scoped=true&lang=html"
import script from "./kycForm.vue?vue&type=script&lang=js"
export * from "./kycForm.vue?vue&type=script&lang=js"

import "./kycForm.vue?vue&type=style&index=0&id=4492b94a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4492b94a"]])

export default __exports__